/* House of Holo theme behaviour */
(function () {
  'use strict';
  var mqMobile = window.matchMedia('(max-width: 989px)');

  document.querySelectorAll('[data-mega]').forEach(function (item) {
    var link = item.querySelector('.hoh-nav__link');
    if (!item.querySelector('.hoh-mega')) return;
    item.addEventListener('mouseenter', function () { link.setAttribute('aria-expanded', 'true'); });
    item.addEventListener('mouseleave', function () { link.setAttribute('aria-expanded', 'false'); item.classList.remove('is-open'); });
    item.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { item.classList.remove('is-open'); link.setAttribute('aria-expanded', 'false'); link.focus(); }
    });
  });

  var drawer = document.querySelector('[data-drawer]');
  if (drawer) {
    var title = drawer.querySelector('[data-drawer-title]');
    var back = drawer.querySelector('[data-panel-back]');
    var show = function (id) {
      drawer.querySelectorAll('[data-panel]').forEach(function (p) { p.classList.toggle('is-active', p.getAttribute('data-panel') === id); });
      var top = id === 'root';
      title.hidden = !top; back.hidden = top;
      drawer.querySelector('.hoh-drawer__body').scrollTop = 0;
    };
    var open = function () {
      drawer.classList.add('is-open'); drawer.setAttribute('aria-hidden', 'false');
      document.documentElement.style.overflow = 'hidden';
      document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      show('root');
    };
    var close = function () {
      drawer.classList.remove('is-open'); drawer.setAttribute('aria-hidden', 'true');
      document.documentElement.style.overflow = '';
      document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
    };
    document.querySelectorAll('[data-drawer-open]').forEach(function (b) { b.addEventListener('click', open); });
    drawer.querySelectorAll('[data-drawer-close]').forEach(function (b) { b.addEventListener('click', close); });
    drawer.querySelectorAll('[data-panel-go]').forEach(function (b) {
      b.addEventListener('click', function () { show(b.getAttribute('data-panel-go')); });
    });
    back.addEventListener('click', function () { show('root'); });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer.classList.contains('is-open')) close(); });
  }

  document.querySelectorAll('[data-tabs]').forEach(function (wrap) {
    var tabs = wrap.querySelectorAll('[data-tab]');
    tabs.forEach(function (t) {
      t.addEventListener('click', function () {
        var id = t.getAttribute('data-tab');
        tabs.forEach(function (x) { x.setAttribute('aria-selected', x === t ? 'true' : 'false'); });
        wrap.querySelectorAll('.tabpanel').forEach(function (p) { p.hidden = p.id !== 'panel-' + id; });
        wrap.querySelectorAll('[data-tab-link]').forEach(function (a) { a.hidden = a.getAttribute('data-tab-link') !== id; });
      });
    });
  });

  document.querySelectorAll('[data-countdown]').forEach(function (el) {
    var target = new Date(el.getAttribute('data-countdown')).getTime();
    if (isNaN(target)) { el.hidden = true; return; }
    var d = el.querySelector('[data-d]'), h = el.querySelector('[data-h]'), m = el.querySelector('[data-m]');
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var diff = Math.max(0, target - Date.now());
      if (diff === 0) { el.hidden = true; return; }
      d.textContent = Math.floor(diff / 864e5);
      h.textContent = pad(Math.floor(diff / 36e5) % 24);
      m.textContent = pad(Math.floor(diff / 6e4) % 60);
    };
    tick(); setInterval(tick, 30000);
  });

  var setCols = function () {
    document.querySelectorAll('[data-fcol]').forEach(function (d) { d.open = !mqMobile.matches; });
  };
  setCols();
  if (mqMobile.addEventListener) mqMobile.addEventListener('change', setCols);
  document.querySelectorAll('[data-fcol] summary').forEach(function (s) {
    s.addEventListener('click', function (e) { if (!mqMobile.matches) e.preventDefault(); });
  });

  var toast = document.querySelector('.hoh-toast');
  var say = function (msg) {
    if (!toast) return;
    toast.textContent = msg; toast.hidden = false;
    clearTimeout(say._t); say._t = setTimeout(function () { toast.hidden = true; }, 2600);
  };
  var setCount = function (n) {
    document.querySelectorAll('[data-cart-count]').forEach(function (c) { c.textContent = n; c.setAttribute('data-count', n); });
    document.querySelectorAll('[data-cart-link]').forEach(function (a) { a.setAttribute('aria-label', 'Basket, ' + n + ' items'); });
  };
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.matches('[data-hoh-add]')) return;
    e.preventDefault();
    var btn = form.querySelector('[type="submit"]');
    if (btn) btn.disabled = true;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    fetch(root + 'cart/add.js', { method: 'POST', headers: { 'Accept': 'application/json' }, body: new FormData(form) })
      .then(function (r) { return r.json().then(function (j) { return { ok: r.ok, j: j }; }); })
      .then(function (res) {
        if (!res.ok) { say(res.j.description || res.j.message || 'Could not add to basket'); return; }
        say('Added to basket');
        return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); });
      })
      .catch(function () { form.submit(); })
      .finally(function () { if (btn) btn.disabled = false; });
  });
})();
